import {
  i18nTranslate,
  getLiveEventStatus,
  trackGTMEvents,
  convertToBoolean,
  isFeatureEnabled,
} from 'src/utils'
import {
  FaTruckMoving as OrderHistoryIcon,
  FaAddressCard as AddressBookIcon,
  FaRegCreditCard as PaymentCardIcon,
  FaUserCog as AccountProfileIcon,
  FaUserFriends as TeamManagementIcon,
  FaGift as rewardCreditIcon,
  FaHeart as favoriteIcon,
  FaUserLock as securityIcon,
  FaLock as Lock,
  FaMoneyBillAlt as Bill,
  FaWpexplorer as explorerIcon,
  FaWallet as WalletIcon,
} from 'react-icons/fa'
import isArray from 'lodash/isArray'
import {
  IoMdBusiness as CostCenterIcon,
  IoMdDocument as ContractIcon,
  IoIosSettings as SettingsIcon,
  IoIosListBox as ListsIcon,
} from 'react-icons/io'
import {
  MdAccountCircle as ProfileIcon,
  MdPerson as UserManagementIcon,
  MdRestore as SubscriptionIcon,
  MdLocalOffer as ProductOfferIcon,
} from 'react-icons/md'
import { GiPerson as OutfitIcon } from 'react-icons/gi'
import { getAppConfig } from 'config/appConfig/configUtils'
import {
  enableOutfits,
  enableSubscription,
  enableWishList,
} from 'config/appConfig'
import {
  ACCOUNT_TYPE_BRAND_AFFILIATE,
  ACCOUNT_TYPE_BRAND_AFFILIATE_BUSINESS,
} from 'src/utils/constant'
import { pageNames } from 'src/routes/pathParams'
import {
  isB2BAdmin,
  isB2BUser,
  isB2B2C,
  setLocalStorage,
  getLocalStorage,
  isB2B2CAdmin,
} from 'src/utils'
import { getLocaleCodeFromUrl, isLATAM } from 'src/utils/localeUtils'
import {
  accountsContainer,
  customerContainer,
  storeContainer,
  userContainer,
} from 'src/models'
import { commonContainer } from 'src/models'
import { isLoyEnableInProf } from 'src/views/pages/MyAccount/MyAccountProfile/LoyaltyForm/fixture.js'
import { APPConfig } from 'config/appConfig'
import { enableAccountSettings, enableProductOfferAdmin } from 'src/utils'

const enableLiveEvent = getLiveEventStatus()
const enableListMenu =
  convertToBoolean(APPConfig?.getAppConfig()?.enableListMenu) || false
const activeLocale = getLocaleCodeFromUrl({
  isReverseType: true,
})
const [lang, country] = activeLocale?.split('-') || []
let userDataWithoutSize = ''
const getProfile = async () => {
  const loadParams = {
    endPointName: 'getProfile',
  }
  const response = await commonContainer.fetchResponse(loadParams)
  if (response?.accounts?.type) {
    setLocalStorage('accountType', response.accounts.type)
  }
  const enableLiveEvent = getLiveEventStatus()
  if (enableLiveEvent === 'true') {
    trackGTMEvents({
      event: 'view_my_profile',
    })
  }
  return response
}
getProfile()
// accountsContainer.getAccountTypes()
accountsContainer?.getNexGenAccountTypes()
const accproperties = accountsContainer?.profileResponse?.properties
const spid =
  accproperties && accproperties.find(list => list.attributeId === 'sponsorId')
const sponsorId = spid?.value || ''
customerContainer.sponsorIdValidation(sponsorId)
const getUserListWithoutSize = async () => {
  const Data = await userContainer.getUserListWithoutSize()
  userDataWithoutSize = isArray(Data?.accountBuyer)
    ? Data?.accountBuyer[0]?.buyerInfo
    : {}
  setLocalStorage('admnEmail', userDataWithoutSize.email)
  setLocalStorage('admnPhoneNumber', userDataWithoutSize.phoneNumber)
}
getUserListWithoutSize()

// Helpers to simplify `b2bAdminSideBar` and reduce cognitive complexity
function getParticipantsMenuClassName(type, enableJoint) {
  if (!enableJoint) {
    return type === ACCOUNT_TYPE_BRAND_AFFILIATE_BUSINESS &&
      isB2B2CAdmin() === true
      ? ''
      : 'd-none'
  }
  const shouldDisplayParticipantsMenu =
    type === ACCOUNT_TYPE_BRAND_AFFILIATE_BUSINESS ||
    type === ACCOUNT_TYPE_BRAND_AFFILIATE
  return shouldDisplayParticipantsMenu ? '' : 'd-none'
}

function getAssociatesLabelAndLink(enableJoint) {
  return {
    label: enableJoint
      ? i18nTranslate('myaccount.participants', 'Participants')
      : i18nTranslate('myaccount.b2bUserManagementMessage', 'Associates'),
    link: enableJoint ? pageNames.participants : pageNames.b2bUserManagement,
  }
}

function b2bAdminSideBar() {
  const type = getLocalStorage('accountType')
  const enableJointAccountParticipants = convertToBoolean(
    APPConfig?.getAppConfig()?.enableJointAccountParticipants
  )
  const participantsMenuClassName = getParticipantsMenuClassName(
    type,
    enableJointAccountParticipants
  )
  const { label: labelForAssociates, link: linkForAssociates } =
    getAssociatesLabelAndLink(enableJointAccountParticipants)
  const list = [
    // {
    //   label: i18nTranslate('myaccount.b2bdashBoard', 'Dashboard'),
    //   link: pageNames.b2bDashBoard,
    //   icon: DashboardIcon,
    // }
    {
      label: i18nTranslate('myaccount.b2bMyProfile', 'My Profile'),
      link: pageNames.b2bMyProfile,
      icon: ProfileIcon,
      dataTestid: 'qa-my-profile',
    },
    {
      label: i18nTranslate('myaccount.b2bAccountProfile', 'Account Profile'),
      link: pageNames.b2bAccountProfile,
      icon: AccountProfileIcon,
      dataTestid: 'qa-account-profile',
    },
    {
      label: i18nTranslate('myaccount.b2bAddressBook', 'Address Book'),
      link: pageNames.myaccountshipping,
      icon: AddressBookIcon,
      dataTestid: 'qa-address-book',
    },
    {
      label: isLoyEnableInProf()
        ? i18nTranslate('myaccount.rewardsandcredits', 'Rewards & Credits')
        : i18nTranslate('myaccount.storecredits', 'Store Credits'),
      link: pageNames.myaccountrewardsandcredits,
      icon: rewardCreditIcon,
      dataTestid: 'qa-rewards-credits',
    },

    {
      label: i18nTranslate('myaccount.b2bContractList', 'Contract'),
      link: pageNames.b2bContractList,
      icon: ContractIcon,
      dataTestid: 'qa-contract',
    },
    {
      label: i18nTranslate('myaccount.b2bCostCenterMessage', 'Cost Centers'),
      link: pageNames.b2bCostCenter,
      icon: CostCenterIcon,
      dataTestid: 'qa-cost-centers',
    },
    {
      label: i18nTranslate('myaccount.b2bTeamManagementMessage', 'Teams'),
      link: pageNames.b2bTeamManagement,
      icon: TeamManagementIcon,
      dataTestid: 'qa-teams',
    },
    // {
    //   label: i18nTranslate('myaccount.b2bApprovals', 'Approvals'),
    //   link: pageNames.b2bApprovals,
    //   icon: ApprovalIcon,
    // },
    {
      label: labelForAssociates,
      link: linkForAssociates,
      icon: UserManagementIcon,
      dataTestid: 'qa-users',
      customClassName: participantsMenuClassName,
    },
    {
      label: i18nTranslate('myaccount.orders', 'Order History'),
      link: pageNames.myaccountorders,
      icon: OrderHistoryIcon,
      dataTestid: 'qa-order-history',
    },
  ]
  if (enableWishList && !isLATAM() && enableListMenu) {
    list.push({
      label: i18nTranslate('myaccount.lists', 'Lists'),
      link: pageNames.myaccountlists,
      icon: ListsIcon,
      dataTestid: 'qa-lists',
    })
  }

  // labels can be changed in locale files
  list.push({
    label:
      country === 'US'
        ? i18nTranslate('myaccount.favourites.US', 'Favorites')
        : i18nTranslate('myaccount.favourites', 'Favorites'),
    link: pageNames.myaccountfavourites,
    icon: favoriteIcon,
    dataTestid: 'qa-favourites',
  })

  if (enableSubscription) {
    list.push({
      label: i18nTranslate('myaccount.subscriptions', 'Subscriptions'),
      link: pageNames.myaccountsubscriptions,
      icon: SubscriptionIcon,
      dataTestid: 'qa-subscriptions',
    })
  }
  if (
    enableProductOfferAdmin() &&
    (type === ACCOUNT_TYPE_BRAND_AFFILIATE ||
      type === ACCOUNT_TYPE_BRAND_AFFILIATE_BUSINESS)
  ) {
    list.push({
      label: i18nTranslate('myaccount.productOffer', 'Product Offer'),
      link: pageNames.productOfferAdmin,
      icon: ProductOfferIcon,
      dataTestid: 'qa-product-offer',
    })
  }
  if (enableAccountSettings()) {
    list.push({
      label: i18nTranslate('myaccount.accountSettings', 'Account Settings'),
      link: pageNames.accountSettings,
      icon: SettingsIcon,
      dataTestid: 'qa-settings',
    })
  }

  return list
}
function b2b2cSideBar() {
  const list = []
  // if (isB2B2CAdmin()) {
  //   list.push({
  //     label: i18nTranslate('myaccount.b2bdashBoard', 'Dashboard'),
  //     link: pageNames.b2bDashBoard,
  //     icon: DashboardIcon,
  //   })
  // }
  const hideDirectDeposit = convertToBoolean(
    APPConfig?.getAppConfig()?.hideDirectDeposit
  )
  const type = getLocalStorage('accountType')
  if (
    type === ACCOUNT_TYPE_BRAND_AFFILIATE ||
    type === ACCOUNT_TYPE_BRAND_AFFILIATE_BUSINESS
  ) {
    list.push({
      label: i18nTranslate('myaccount.volumes', 'Volumes'),
      link: pageNames.myaccountvolumes,
      // icon: VolumeIcon,
      dataTestid: 'qa-volumes',
    })
  }
  list.push({
    label: i18nTranslate('myaccount.b2bMyProfile', 'My Profile'),
    link: pageNames.b2bMyProfile,
    icon: ProfileIcon,
    dataTestid: 'qa-my-profile',
  })
  if (enableAccountSettings()) {
    list.push({
      label: i18nTranslate('myaccount.accountSettings', 'Account Settings'),
      link: pageNames.accountSettings,
      icon: SettingsIcon,
      dataTestid: 'qa-settings',
    })
  }
  list.push({
    label: i18nTranslate('myaccount.b2bAccountProfile', 'Account Profile'),
    link: pageNames.b2bAccountProfile,
    icon: AccountProfileIcon,
    dataTestid: 'qa-account-profile',
  })
  list.push({
    label: i18nTranslate('myaccount.security', 'Security'),
    link: pageNames.security,
    icon: securityIcon,
    dataTestid: 'qa-security',
  })
  if (
    type === ACCOUNT_TYPE_BRAND_AFFILIATE ||
    type === ACCOUNT_TYPE_BRAND_AFFILIATE_BUSINESS
  ) {
    list.push({
      label: i18nTranslate('myaccount.mysite', 'My Site Admin'),
      link: pageNames.mysite,
      icon: explorerIcon,
      dataTestid: 'qa-mysite',
    })
  }

  if (
    enableProductOfferAdmin() &&
    (type === ACCOUNT_TYPE_BRAND_AFFILIATE ||
      type === ACCOUNT_TYPE_BRAND_AFFILIATE_BUSINESS)
  ) {
    list.push({
      label: i18nTranslate('myaccount.productOffer', 'Product Offer'),
      link: pageNames.productOfferAdmin,
      icon: ProductOfferIcon,
      dataTestid: 'qa-product-offer',
    })
  }

  const StoreIdBasedOnCountry = storeContainer.storeIDValue || ''
  // let homeCountry = getLocalStorage('homeCountry') || ''

  let homeCountry = customerContainer.getUserHomeCountry()
  customerContainer?.profileResponse?.accounts?.properties?.forEach(element => {
    if (element?.attributeId === 'countryCode') {
      homeCountry = element?.value || ''
    }
  })
  if (homeCountry === 'CA') {
    homeCountry = 'Canada'
  }
  const personType =
    customerContainer.profileResponse?.customProperties?.personType || ''

  const enableJointAccountParticipants = convertToBoolean(
    APPConfig?.getAppConfig()?.enableJointAccountParticipants
  )

  const labelForAssociates = enableJointAccountParticipants
    ? i18nTranslate('myaccount.participants', 'Participants')
    : i18nTranslate('myaccount.b2bUserManagementMessage', 'Associates')

  const linkForAssociates = enableJointAccountParticipants
    ? pageNames.participants
    : pageNames.b2bUserManagement

  list.push(
    {
      label: i18nTranslate('myaccount.b2bAddressBook', 'Shipping Address Book'),
      link: pageNames.myaccountshipping,
      icon: AddressBookIcon,
      dataTestid: 'qa-shipping-address-book',
    },
    {
      label: i18nTranslate('myaccount.payments', 'Payments'),
      link: pageNames.myaccountpayment,
      icon: PaymentCardIcon,
      dataTestid: 'qa-payments',
    }
  )
  // sometimes homeCountry is missing
  // adding fallback
  if (homeCountry ? StoreIdBasedOnCountry === homeCountry : true) {
    list.push({
      label: isLoyEnableInProf()
        ? i18nTranslate('myaccount.rewardsandcredits', 'Rewards & Credits')
        : i18nTranslate('myaccount.storecredits', 'Store Credits'),
      link: pageNames.myaccountrewardsandcredits,
      icon: rewardCreditIcon,
      dataTestid: 'qa-loyalty-points',
    })
  }
  if (
    (type === ACCOUNT_TYPE_BRAND_AFFILIATE_BUSINESS ||
      type === ACCOUNT_TYPE_BRAND_AFFILIATE) &&
    isB2B2CAdmin() === true &&
    personType?.toLowerCase() === 'primary'
  ) {
    list.push({
      label: labelForAssociates,
      link: linkForAssociates,
      icon: UserManagementIcon,
      dataTestid: 'qa-users',
    })
  }
  list.push({
    label: i18nTranslate('myaccount.orders', 'Order History'),
    link: pageNames.myaccountorders,
    icon: OrderHistoryIcon,
    dataTestid: 'qa-order-history',
  })
  if (enableWishList && !isLATAM() && enableListMenu) {
    list.push({
      label: i18nTranslate('myaccount.lists', 'Lists'),
      link: pageNames.myaccountlists,
      icon: ListsIcon,
      dataTestid: 'qa-list',
    })
  }
  if (
    !hideDirectDeposit &&
    (type === ACCOUNT_TYPE_BRAND_AFFILIATE ||
      type === ACCOUNT_TYPE_BRAND_AFFILIATE_BUSINESS)
  ) {
    list.push({
      label: i18nTranslate('myaccount.deposit', 'Direct Deposit'),
      link: pageNames.myaccountdeposit,
      icon: Bill,
      dataTestid: 'qa-direct-deposit',
    })
  }

  list.push({
    label:
      country === 'US'
        ? i18nTranslate('myaccount.favourites.US', 'Favorites')
        : i18nTranslate('myaccount.favourites', 'Favourites'),
    link: pageNames.myaccountfavourites,
    icon: favoriteIcon,
    iconClassName: 'favorites-icon',
    dataTestid: 'qa-favorites',
  })

  if (enableSubscription) {
    list.push({
      label: i18nTranslate('myaccount.subscriptions', 'Subscriptions'),
      link: pageNames.myaccountsubscriptions,
      icon: SubscriptionIcon,
      dataTestid: 'qa-subscriptions',
    })
  }
  list.push({
    label: i18nTranslate('myaccount.privacy', 'Privacy'),
    link: pageNames.myaccountprivacy,
    icon: Lock,
    dataTestid: 'qa-privacy',
  })
  const enableAccountWallet = isFeatureEnabled('enableAccountWallet')
  if (enableAccountWallet) {
    list.push({
      label: i18nTranslate('myaccount.wallet', 'Wallet'),
      link: pageNames.myaccountwallet,
      icon: WalletIcon,
      dataTestid: 'qa-accountwallet',
    })
  }
  const disableFeatureForRP = customerContainer?.disableFeaturesForRPReview()
  if (disableFeatureForRP) {
    const removeSideBarItems = [
      i18nTranslate('myaccount.wallet', 'Wallet'),
      i18nTranslate('myaccount.storecredits', 'Store Credits'),
      i18nTranslate('myaccount.payments', 'Payments'),
      i18nTranslate('myaccount.privacy', 'Privacy'),
      i18nTranslate('myaccount.subscriptions', 'Subscriptions'),
      i18nTranslate('myaccount.favourites.US', 'Favorites'),
    ]
    return list.filter(item => !removeSideBarItems?.includes(item.label))
  }
  return list
}
function renderProfile() {
  if (isB2BUser() === true) {
    return {
      label: i18nTranslate('myaccount.b2bMyProfile', 'My Profile'),
      link: pageNames.b2bMyProfile,
      icon: ProfileIcon,
      dataTestid: 'qa-my-profile',
    }
  }
  return {
    label: i18nTranslate('myaccount.b2bMyProfile', 'My Profile'),
    link: pageNames.b2bMyProfile,
    icon: ProfileIcon,
    dataTestid: 'qa-my-profile',
  }
}
function b2cAccountSideBar() {
  const list = []
  const type = getLocalStorage('accountType')
  const sideBar = [
    {
      label: i18nTranslate('myaccount.b2bMyProfile', 'My Profile'),
      link: pageNames.b2bMyProfile,
      icon: ProfileIcon,
      dataTestid: 'qa-my-profile',
    },
    {
      label: i18nTranslate('myaccount.b2bAccountProfile', 'Account Profile'),
      link: pageNames.b2bAccountProfile,
      icon: AccountProfileIcon,
      dataTestid: 'qa-account-profile',
    },
    {
      label: i18nTranslate('myaccount.security', 'Security'),
      link: pageNames.security,
      icon: securityIcon,
      dataTestid: 'qa-security',
    },
  ]
  if (
    type === ACCOUNT_TYPE_BRAND_AFFILIATE ||
    type === ACCOUNT_TYPE_BRAND_AFFILIATE_BUSINESS
  ) {
    list.push({
      label: i18nTranslate('myaccount.mysite', 'My Site Admin'),
      link: pageNames.mysite,
      icon: explorerIcon,
      dataTestid: 'qa-mysite',
    })
  }
  sideBar.push({
    label: i18nTranslate('myaccount.shipping', 'Shipping Address Book'),
    link: pageNames.myaccountshipping,
    icon: AddressBookIcon,
    dataTestid: 'qa-shipping-address-book',
  })

  if (getAppConfig().businessRelationship === 'B2C') {
    sideBar.push({
      label: i18nTranslate('myaccount.payments', 'Payments'),
      link: pageNames.myaccountpayment,
      icon: PaymentCardIcon,
      dataTestid: 'qa-payments',
    })
  }

  const storeIdBasedOnCountry = storeContainer.storeIDValue || ''
  let homeCountry = ''
  customerContainer?.profileResponse?.accounts?.properties?.forEach(element => {
    if (element.attributeId === 'countryCode') {
      homeCountry = element.value
    }
  })
  const accounttType = customerContainer?.profileResponse?.accounts?.type || ''
  if (homeCountry === 'CA') {
    homeCountry = 'Canada'
  }
  // sometimes homeCountry is missing
  // adding fallback
  if (
    homeCountry
      ? storeIdBasedOnCountry === homeCountry
      : true || accounttType === ACCOUNT_TYPE_BRAND_AFFILIATE
  ) {
    sideBar.push({
      label: isLoyEnableInProf()
        ? i18nTranslate('myaccount.rewardsandcredits', 'Rewards & Credits')
        : i18nTranslate('myaccount.storecredits', 'Store Credits'),
      link: pageNames.myaccountrewardsandcredits,
      icon: rewardCreditIcon,
      dataTestid: 'qa-loyalty-points',
    })
  }
  sideBar.push({
    label: i18nTranslate('myaccount.orders', 'Order History'),
    link: pageNames.myaccountorders,
    icon: OrderHistoryIcon,
    dataTestid: 'qa-order-history',
  })

  if (enableWishList && !isLATAM() && enableListMenu) {
    sideBar.push({
      label: i18nTranslate('myaccount.lists', 'Lists'),
      link: pageNames.myaccountlists,
      icon: ListsIcon,
      dataTestid: 'qa-lists',
    })
  }

  sideBar.push({
    label:
      country === 'US'
        ? i18nTranslate('myaccount.favourites.US', 'Favorites')
        : i18nTranslate('myaccount.favourites', 'Favourites'),
    link: pageNames.myaccountfavourites,
    icon: favoriteIcon,
    iconClassName: 'favorites-icon',
    dataTestid: 'qa-favorites',
  })

  if (enableSubscription) {
    sideBar.push({
      label: i18nTranslate('myaccount.subscriptions', 'Subscriptions'),
      link: pageNames.myaccountsubscriptions,
      icon: SubscriptionIcon,
      dataTestid: 'qa-subscriptions',
    })
  }
  enableOutfits &&
    sideBar.push({
      label: i18nTranslate('myaccount.mycloset', 'My Closet'),
      link: pageNames.myaccountmycloset,
      icon: OutfitIcon,
      dataTestid: 'qa-my-closet',
    })
  sideBar.push(
    {
      label: i18nTranslate('myaccount.settings', 'Settings'),
      link: pageNames.myaccountsettings,
      icon: SettingsIcon,
      dataTestid: 'qa-settings',
    },
    {
      label: i18nTranslate('myaccount.privacy', 'Privacy'),
      link: pageNames.myaccountprivacy,
      icon: Lock,
      dataTestid: 'qa-privacy',
    }
  )
  const enableAccountWallet = isFeatureEnabled('enableAccountWallet')
  if (enableAccountWallet) {
    sideBar.push({
      label: i18nTranslate('myaccount.wallet', 'Wallet'),
      link: pageNames.myaccountwallet,
      icon: Lock,
      dataTestid: 'qa-accountwallet',
    })
  }
  if (enableAccountSettings()) {
    sideBar.push({
      label: 'Account Settings',
      link: pageNames.accountSettings,
      icon: SettingsIcon,
      dataTestid: 'qa-settings',
    })
  }
  return sideBar
}
function myAccountSideBar() {
  let sideBar = isB2BAdmin() ? b2bAdminSideBar() : b2cAccountSideBar()
  if (isB2B2C()) {
    sideBar = b2b2cSideBar()
  }
  if (enableLiveEvent === 'true') {
    sideBar = eventAccountSideBar()
  }
  return sideBar
}

function eventAccountSideBar() {
  const list = [
    {
      label: i18nTranslate('myaccount.b2bMyProfile', 'My Profile'),
      link: pageNames.b2bMyProfile,
      icon: ProfileIcon,
      dataTestid: 'qa-my-profile',
    },
    {
      label: i18nTranslate('myaccount.b2bAccountProfile', 'Account Profile'),
      link: pageNames.b2bAccountProfile,
      icon: AccountProfileIcon,
      dataTestid: 'qa-account-profile',
    },
    {
      label: i18nTranslate('myaccount.payments', 'Payments'),
      link: pageNames.myaccountpayment,
      icon: PaymentCardIcon,
      dataTestid: 'qa-payments',
    },
    {
      label: i18nTranslate('myaccount.storecredits', 'Store Credits'),
      link: pageNames.myaccountrewardsandcredits,
      icon: rewardCreditIcon,
      dataTestid: 'qa-loyalty-points',
    },
    {
      label: i18nTranslate('myaccount.orders', 'Order History'),
      link: pageNames.myaccountorders,
      icon: OrderHistoryIcon,
      dataTestid: 'qa-order-history',
    },
  ]

  return list
}
export { myAccountSideBar }
